import React from 'react'
import { Table } from 'react-bootstrap'
import Aos from 'aos'
import '../../css/membership.css'
import MemberForm from '../../Files/Membership/Membership-Application.pdf'
import KOMForm from '../../Files/Membership/KOM-2081.pdf'
import MBankForm from '../../Files/Membership/mbank-Application-Form.pdf'

const Membership = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    const MembershipData = [
        {
            id: '१',
            title: 'नयाँ सदस्य दर्ता फारम',
            pdfUrl: MemberForm
        },
        {
            id: '२',
            title: 'के.ओ.एम फारम (KOM)',
            pdfUrl: KOMForm
        },
        {
            id: '३',
            title: 'मोबाइल बैङकिङ दर्ता फारम',
            pdfUrl: MBankForm
        },
    ]

    const handleOpenPdf = (pdfUrl, isDownload) => {
        const link = document.createElement('a');
        link.href = pdfUrl;
        if (isDownload) {
            link.setAttribute('download', '')
        }
        else {
            link.setAttribute('target', '_blank')
        }
        link.click();
    }

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='membership-body'>
                    <div className='body-1'>
                        <div className='membership-header'>
                            <h3>शेयर सदस्य बन्नको लागि आवस्यक कागजात/रकम</h3>
                        </div>
                        <div className='bg-white rounded shadow table-body'>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>क्र.स.</th>
                                        <th>शीर्षक</th>
                                        <th>रकम रु.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>१.</td>
                                        <td>सेयर</td>
                                        <td>१०००</td>
                                    </tr>
                                    <tr>
                                        <td>२.</td>
                                        <td>नियमित मासिक बचत</td>
                                        <td>३००</td>
                                    </tr>
                                    <tr>
                                        <td>३.</td>
                                        <td>ऐच्छिक बचत</td>
                                        <td>१००</td>
                                    </tr>
                                    <tr>
                                        <td>४.</td>
                                        <td>राहत रकम</td>
                                        <td>३००</td>
                                    </tr>
                                    <tr>
                                        <td>५.</td>
                                        <td>प्रवेश शुल्क</td>
                                        <td>१००</td>
                                    </tr>
                                    <tr>
                                        <td>६.</td>
                                        <td>निवेदन शुल्क</td>
                                        <td>१००</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            जम्मा
                                        </td>
                                        <td>१९००</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3} style={{ fontWeight: 600 }}>
                                            द्रष्टब्य: आ.व.को अन्त्यमा नियमित मासिक बचत रु.३,०००।– र सेयर रकम रु. ३,००० अनिवार्य पुर्याउनु पर्नेछ
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    <div className='body-2'>
                        <div className='membership-header'>
                            <h3>सदस्य बन्नको लागि चाहिने आवश्यक फारमहरु</h3>
                        </div>
                        <div className='bg-white rounded shadow table-body'>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>क्र.स.</th>
                                        <th>शीर्षक</th>
                                        <th>विकल्प</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {MembershipData.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{item.id}</td>
                                            <td>{item.title}</td>
                                            <td className='option'>
                                                <button
                                                    className='show-button'
                                                    onClick={() => handleOpenPdf(item.pdfUrl, false)}
                                                >
                                                    View
                                                </button>
                                                <strong>अथवा</strong>
                                                <button
                                                    className='show-button'
                                                    onClick={() => handleOpenPdf(item.pdfUrl, true)}
                                                >
                                                    Download
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    <div className='body-3'>
                        <div className='membership-header'>
                            <h3>ऋण सुविधा प्राप्त गर्न चाहिने आवस्यक कागजातहरु</h3>
                        </div>
                        <div className='bg-white rounded shadow table-body'>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>क्र.स.</th>
                                        <th>शीर्षक</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>१.</td>
                                        <td>ऋण माग फारम</td>
                                    </tr>
                                    <tr>
                                        <td>२.</td>
                                        <td>नक्सा (फायल र फिल्ड)</td>
                                    </tr>
                                    <tr>
                                        <td>३.</td>
                                        <td>मालपोत (एकीकृत सम्पत्ति कर) तिरेको रसिद</td>
                                    </tr>
                                    <tr>
                                        <td>४.</td>
                                        <td>जग्गा धनिपुर्जा</td>
                                    </tr>
                                    <tr>
                                        <td>५.</td>
                                        <td>आम्दानीको स्रोत खुल्ने कागजात</td>
                                    </tr>
                                    <tr>
                                        <td>६.</td>
                                        <td>सेयर प्रमाणपत्रको प्रतिलिपी</td>
                                    </tr>
                                    <tr>
                                        <td>७.</td>
                                        <td>चारकिल्ला प्रमाणित कागजात</td>
                                    </tr>
                                    <tr>
                                        <td>८.</td>
                                        <td>नागरिकताको फोटोकपी (सदस्य र जग्गाधनीको)</td>
                                    </tr>
                                    <tr>
                                        <td>९.</td>
                                        <td>हालसालै खिचिएको पासपोर्ट साइजको फोटो (सदस्य र जग्गाधनीको)</td>
                                    </tr>
                                    <tr>
                                        <td>१०.</td>
                                        <td>जग्गा वर्गीकरण नक्सा</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Membership